// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/fonts/font.css';
import './less/main.less';

import ElementUI from 'element-ui';
import locale from '../node_modules/element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';

import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'

import mixin from "./mixin/global"
import axios from 'axios'
import store from './store/'
import common from "./components/" //加载公共组件
import filter from './filter/'

Vue.config.productionTip = false;

Object.keys(common).forEach((key) => {
  const name = key.replace(/(\w)/, (v) => v.toUpperCase()); //首字母大写
  Vue.component(`common${name}`, common[key]);
});

filter(Vue);

Vue.prototype.axios = axios;
Vue.use(VueRouter);
Vue.use(ElementUI, {locale});
Vue.mixin(mixin);

let scrWidth = document.documentElement.clientWidth;

router.beforeEach((to, from, next) => {
  if (to.query.id !== 'contact') {
    // 兼容chrome
    document.body.scrollTop = 0
    // 兼容firefox
    document.documentElement.scrollTop = 0
  }
  if (scrWidth < 900 && (to.path === '/' || to.name === 'homePage')) {
    next({ path: '/m', query: { zh: 'en' }});
  } else if (scrWidth >= 1280 && (to.path === '/m' || to.name === 'mHomePage')) {
    next({ path: '/', query: { zh: 'en' } });
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js